let LOGIN;
let READ;
if (process.env.NODE_ENV === 'production') {
  // 生产环境
  LOGIN = 'https://my.wanfangdata.com.cn/';
  READ = 'https://oss.wanfangdata.com.cn/';
} else if (process.env.NODE_ENV === 'test' || process.env.NODE_ENV === 'development') {
  // 测试环境
  LOGIN = 'http://my.rd.wanfangdata.com.cn/';
  READ = 'http://oss.rd.wanfangdata.com.cn/';
}
// 常量
export const IMG_BASE_URL = 'http://static.wanfangdata.com.cn/LocalChronicleImages/'
export const IMG_DEFAULT_URL = 'this.src="http://static.wanfangdata.com.cn/LocalChronicleImages/FZ201745248.gif"'
export const LOGIN_IN_URL = LOGIN + `auth/user/jglogin.do?service=`
export const LOGIN_OUT_URL = LOGIN + `auth/logout?service=`
// 阅读下载URL
export const READ_URL = READ + `fz/purchase?id=`
export const RESOURCE_TYPE_ITEM_READ = '&resourceType=localChronicleItemEdu'
export const RESOURCE_TYPE_ITEM_DOWN = '&resourceType=localChronicleItemEduDownload'
export const RESOURCE_TYPE_BOOK_READ = '&resourceType=localChronicleEdu'
export const RESOURCE_TYPE_BOOK_DOWN = '&resourceType=localChronicleEduDownload'
export const RESOURCE_TYPE_READ = '&resourceType=localChronicleEdu'



// WEBPACK FOOTER //
// ./src/assets/constant.js